import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { styled } from '@mui/material';
import { H4 } from '../../atoms/typography';
import ImageWithZoom from '../../molecules/ImageWithZoom';
const ItemCardSmallContainer = styled(Card) `
  display: flex;
  width: max-content;
  position: relative;
  margin-bottom: 16px;
  width: 100%;
`;
const StyledCardContent = styled(CardContent) `
  &:last-child {
    padding-bottom: 0;
  }
  display: flex;
  flex-direction: column;
  padding: 24px;
  gap: 16px;
  width: 100%;
`;
const ItemCard = ({ alt = undefined, children, className = '', imageUrl = undefined, itemTitle = 'Product', showWhenNoPhotoAvailable = false, }) => {
    const [isError, setIsError] = useState(false);
    return (_jsxs(ItemCardSmallContainer, { className: className, children: [(imageUrl || !isError) &&
                _jsx(ImageWithZoom, { imageUrl: imageUrl, alt: alt, size: { image: '228px' }, maxZoomWidth: "lg", isZoomable: false, onError: () => setIsError(true), showWhenNoPhotoAvailable: showWhenNoPhotoAvailable }), _jsxs(StyledCardContent, { children: [_jsx(H4, { children: itemTitle }), children] })] }));
};
export default ItemCard;
//# sourceMappingURL=index.js.map